<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_DATES')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_DATES')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">
        <div class="row">
           <div class="col">
                <div class="mb-2">
                    <label>Geschätzte Projektdauer (in Monaten)</label>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ project?.duration | number: '1.0-0' }}
                        <span class="text-danger" *ngIf="project?.duration === null">Berechnung nicht möglich</span>
                    </p>
                </div>
            </div>
        </div>

        <label>Projektzeitraum</label>

        <table class="table table-striped table-sm">
            <thead>
            <tr>
                <th></th>
                <th>PLAN</th>
                <th>IST</th>
                <th>Abweichung [Tage]</th>
                <th>Kommentar</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Projektstart</td>
                <td>
                    <input type="date" class="form-control" formControlName="dates_start_planned" *ngIf="viewMode !== ViewMode.VIEW"
                           [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                    <div *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.dates_start_planned | date: 'dd.MM.yyyy' }}
                        <span class="text-danger" *ngIf="!form.value.dates_start_planned">Nicht eingetragen</span>
                    </div>
                </td>
                <td>
                    <input type="date" class="form-control" formControlName="dates_start_actual" *ngIf="viewMode !== ViewMode.VIEW">
                    <div *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.dates_start_actual | date: 'dd.MM.yyyy' }}
                        <span class="text-muted" *ngIf="!form.value.dates_start_actual">Nicht eingetragen</span>
                    </div>
                </td>
                <td [class.text-success]="project?.dates_start_deviation < 0"
                    [class.text-danger]="project?.dates_start_deviation > 0">
                    <span *ngIf="project?.dates_start_deviation > 0">+</span>{{ project?.dates_start_deviation }}
                </td>
                <td>
                    <input type="text" class="form-control" formControlName="dates_start_comment" *ngIf="viewMode !== ViewMode.VIEW">
                    <div *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.dates_start_comment }}
                        <span class="text-muted" *ngIf="!form.value.dates_start_comment">Nicht eingetragen</span>
                    </div>
                </td>
            </tr>
            <tr>
                <td>Projektende</td>
                <td>
                    <input type="date" class="form-control" formControlName="dates_end_planned" *ngIf="viewMode !== ViewMode.VIEW"
                           [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                    <div *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.dates_end_planned | date: 'dd.MM.yyyy' }}
                        <span class="text-danger" *ngIf="!form.value.dates_end_planned">Nicht eingetragen</span>
                    </div>
                </td>
                <td>
                    <input type="date" class="form-control" formControlName="dates_end_actual" *ngIf="viewMode !== ViewMode.VIEW">
                    <div *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.dates_end_actual | date: 'dd.MM.yyyy' }}
                        <span class="text-muted" *ngIf="!form.value.dates_end_actual">Nicht eingetragen</span>
                    </div>
                </td>
                <td [class.text-success]="project?.dates_end_deviation < 0"
                    [class.text-danger]="project?.dates_end_deviation > 0">
                    <span *ngIf="project?.dates_end_deviation > 0">+</span>{{ project?.dates_end_deviation }}
                </td>
                <td>
                    <input type="text" class="form-control" formControlName="dates_end_comment" *ngIf="viewMode !== ViewMode.VIEW">
                    <div *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.dates_end_comment }}
                        <span class="text-muted" *ngIf="!form.value.dates_end_comment">Nicht eingetragen</span>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>

        <label>Meilensteine ({{getLengthOfFormArray('milestones')}})</label>

        <p class="text-danger" *ngIf="getLengthOfFormArray('milestones') === 0">
            Keine Meilensteine definiert.
            <span *ngIf="viewMode !== ViewMode.VIEW"><br/>Es muss mindestens ein Meilenstein definiert werden.</span>
        </p>

        <table class="table table-striped table-sm" *ngIf="getLengthOfFormArray('milestones') > 0">
            <thead>
            <tr>
                <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th>Bezeichnung</th>
                <th>PLAN</th>
                <th>IST</th>
                <th style="width: 60px">Erfüllt</th>
            </tr>
            </thead>
            <tbody formArrayName="milestones">
            <tr [formGroupName]="i"
                *ngFor="let entry of formService.getFormArray(form, 'milestones').controls; let i = index">
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm"
                                (click)="markEntryAsDeleted(entry)"
                                [disabled]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)"><i
                                class="fas fa-times"></i></button>
                    </td>
                    <td>
                        <textarea class="form-control" formControlName="text" rows="3"
                              placeholder="Beschreibung des Meilensteines"
                              *ngIf="viewMode !== ViewMode.VIEW"
                              [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)"></textarea>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.text }}</ng-container>
                    </td>
                    <td>
                        <input type="date" class="form-control" formControlName="planned"
                               *ngIf="viewMode !== ViewMode.VIEW"
                               [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                        <div *ngIf="viewMode === ViewMode.VIEW">
                            {{ entry.value.planned | date: 'dd.MM.yyyy' }}
                            <span class="text-muted" *ngIf="!entry.value.planned">Nicht eingetragen</span>
                        </div>
                    </td>
                    <td>
                        <input type="date" class="form-control" formControlName="actual"
                               *ngIf="viewMode !== ViewMode.VIEW">
                        <div *ngIf="viewMode === ViewMode.VIEW">
                            {{ entry.value.actual | date: 'dd.MM.yyyy' }}
                            <span class="text-muted" *ngIf="!entry.value.actual">Nicht eingetragen</span>
                        </div>
                    </td>
                    <td>
                        <div class="form-check" *ngIf="viewMode !== ViewMode.VIEW">
                            <input class="form-check-input" formControlName="completed" type="checkbox">
                        </div>
                        <span
                            [class.text-danger]="!entry.value.completed"
                            [class.text-success]="entry.value.completed"
                            *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.completed | yesNo }}
                        </span>
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm"
                    (click)="addFormItem({}, 'milestones')"
                    [disabled]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                <i class="fas fa-plus"></i> Meilenstein hinzufügen
            </button>
        </div>

    </form>
</div>
